angular.module 'zc.core'

.controller 'MainnavCtrl', ($scope, Project, Devise, currentUser) ->
  $scope.Project = Project
  $scope.isMaster = Devise.isMaster()
  $scope.isInternalUser = Devise.isInternalUser()
  $scope.currentUser = currentUser
  $scope.isDisplayAajsWarningMsg = false
  $scope.$watch 'Project.currentProject', (newValue, oldValue) ->
    $scope.projectId = newValue?.id
    $scope.thisMonth = moment().format('YYYY-MM')
    if newValue
      $scope.aiReportURL = "#{ZC_CONFIG.AIDEAL_URL}/site/#{newValue.apikey}/report?period=#{$scope.thisMonth}"
      $scope.isDisplayAajsWarningMsg = newValue.enable_aajs &&
                                       _.some([
                                         newValue.site_id,
                                         newValue.tracking_id,
                                         newValue.scope_id
                                         ],
                                         (item) => !(item && item.length > 0)
                                       )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/controllers/mainnav_controller.js.coffee